<h2>Contact</h2>
Heb je vragen, wil je info, wil je weten wanneer er een infosessie is, mail vrijblijvend naar Erika en Kris (uit Zottegem) <br>
E-mail: letsregiozottegem@yahoo.com of lets.aalst.oudenaarde@gmail.com